'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _icon = require('../../icon');

var _icon2 = _interopRequireDefault(_icon);

var _inputSearchResult = require('../../input-search-result');

var _inputSearchResult2 = _interopRequireDefault(_inputSearchResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Results = function Results(_ref) {
  var active = _ref.active,
      children = _ref.children,
      classNames = _ref.classNames,
      emptyMessage = _ref.emptyMessage,
      errorMessage = _ref.errorMessage,
      _ref$ResultComponent = _ref.ResultComponent,
      ResultComponent = _ref$ResultComponent === undefined ? DefaultResultComponent : _ref$ResultComponent,
      results = _ref.results,
      selectItem = _ref.selectItem,
      status = _ref.status,
      toShow = _ref.toShow;

  if (status === 'fetching') {
    return _react2.default.createElement(
      'div',
      { className: classNames.status },
      _react2.default.createElement(_icon2.default, { name: 'loading', spin: true })
    );
  }

  if (status === 'failed') {
    return _react2.default.createElement(
      'div',
      { className: classNames.status },
      _react2.default.createElement(_icon2.default, { name: 'warning' }),
      ' ',
      errorMessage
    );
  }

  if ((0, _isEmpty2.default)(results)) {
    return _react2.default.createElement(
      'div',
      { className: classNames.status },
      _react2.default.createElement(_icon2.default, { name: 'warning' }),
      ' ',
      emptyMessage
    );
  }

  return _react2.default.createElement(
    'ol',
    { className: classNames.list },
    results.slice(0, toShow).map(function (result, index) {
      return _react2.default.createElement(
        'li',
        { key: index, onClick: function onClick() {
            return selectItem(index, true);
          } },
        _react2.default.createElement(ResultComponent, { isActive: index === active, result: result })
      );
    }),
    children
  );
};

var DefaultResultComponent = function DefaultResultComponent(_ref2) {
  var isActive = _ref2.isActive,
      result = _ref2.result;
  return _react2.default.createElement(
    _inputSearchResult2.default,
    { isActive: isActive },
    result.label
  );
};

exports.default = Results;


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/input-search/results/index.js
// module id = 836
// module chunks = 0